import { useState } from "react";
import { SectionHeader } from "../SectionHeader";
import { ClaimFormContainer } from "./claims/ClaimFormContainer";
import { ClaimsHistorySection } from "./claims/ClaimsHistorySection";

interface ClaimsSectionProps {
  contactId: string;
  isVisible: boolean;
  onToggle: (sectionName: string) => void;
}

export const ClaimsSection = ({
  contactId,
  isVisible,
  onToggle,
}: ClaimsSectionProps) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleClaimSubmitted = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div className="p-6">
          <SectionHeader
            title="Submit a Claim"
            sectionName="claims"
            isVisible={isVisible}
            onToggle={onToggle}
          />
          {isVisible && (
            <ClaimFormContainer 
              contactId={contactId} 
              onSubmitSuccess={handleClaimSubmitted}
            />
          )}
        </div>
      </div>

      {isVisible && (
        <ClaimsHistorySection 
          contactId={contactId} 
          key={refreshTrigger}
        />
      )}
    </div>
  );
};